import { render, staticRenderFns } from "./ShebaNumbers.vue?vue&type=template&id=40408578&"
import script from "./ShebaNumbers.vue?vue&type=script&lang=js&"
export * from "./ShebaNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports